import { FiltrosEditaisAplicadosFormValues } from "./index"

const initialValues:FiltrosEditaisAplicadosFormValues = {
  busca: '',
  filtro1: '',
  filtro2: ''
}

export default initialValues;